<div class="content">

    <!-- Header -->
    <div class="card mb-4">
        <div class="card-header header-elements-inline" [ngBusy]="busy">
            <h5 class="card-title">
                <i class="icon-stats-bars2 mr-2"></i>
                Dashboard — <strong>Eric</strong>
            </h5>
            <div class="heading-elements">
                <button class="btn btn-light btn-xs" (click)="resetFilter()" *ngIf="selectedSousId">
                    <i class="icon-reset mr-1"></i> Réinitialiser le filtre
                </button>
            </div>
        </div>
    </div>

    <!-- Loader -->
    <div class="text-center py-5" *ngIf="isLoading">
        <i class="icon-spinner2 spinner icon-2x text-primary"></i>
        <p class="mt-2 text-muted">Chargement des statistiques...</p>
    </div>

    <div *ngIf="!isLoading && stats">

        <!-- Stats Cards -->
        <div class="row row-cols-1 row-cols-md-3 row-cols-lg-5">

            <!-- Total Clients -->
            <div class="col">
                <div class="card text-center border-0 shadow-sm"
                    style="border-radius: 16px; background: linear-gradient(135deg, #667eea, #764ba2);">
                    <div class="card-body text-white py-4">
                        <i class="icon-users icon-2x mb-2"></i>
                        <h2 class="mb-0 font-weight-bold">{{ stats.total_clients }}</h2>
                        <p class="mb-0 mt-1 opacity-75">Total Clients</p>
                    </div>
                </div>
            </div>

            <!-- Clients Actifs -->
            <div class="col">
                <div class="card text-center border-0 shadow-sm"
                    style="border-radius: 16px; background: linear-gradient(135deg, #11998e, #38ef7d);">
                    <div class="card-body text-white py-4">
                        <i class="icon-checkmark-circle icon-2x mb-2"></i>
                        <h2 class="mb-0 font-weight-bold">{{ stats.actifs }}</h2>
                        <p class="mb-0 mt-1 opacity-75">Clients Actifs</p>
                    </div>
                </div>
            </div>

            <!-- Clients Passifs -->
            <div class="col">
                <div class="card text-center border-0 shadow-sm"
                    style="border-radius: 16px; background: linear-gradient(135deg, #f093fb, #f5576c);">
                    <div class="card-body text-white py-4">
                        <i class="icon-cancel-circle icon-2x mb-2"></i>
                        <h2 class="mb-0 font-weight-bold">{{ stats.passifs }}</h2>
                        <p class="mb-0 mt-1 opacity-75">Clients Passifs</p>
                    </div>
                </div>
            </div>

            <!-- Total HT -->
            <div class="col">
                <div class="card text-center border-0 shadow-sm"
                    style="border-radius: 16px; background: linear-gradient(135deg, #f7971e, #ffd200);">
                    <div class="card-body text-white py-4">
                        <i class="icon-coin-euro icon-2x mb-2"></i>
                        <h2 class="mb-0 font-weight-bold">{{ stats.total_ht | number:'1.2-2' }} €</h2>
                        <p class="mb-0 mt-1 opacity-75">Total HT</p>
                    </div>
                </div>
            </div>
            <!-- Total TTC -->
            <div class="col">
                <div class="card text-center border-0 shadow-sm"
                    style="border-radius: 16px; background: linear-gradient(135deg, #4facfe, #00f2fe);">
                    <div class="card-body text-white py-4">
                        <i class="icon-coin-euro icon-2x mb-2"></i>
                        <h2 class="mb-0 font-weight-bold">{{ stats.total_ttc | number:'1.2-2' }} €</h2>
                        <p class="mb-0 mt-1 opacity-75">Total TTC</p>
                    </div>
                </div>
            </div>

        </div>

        <!-- Filtre Sous-collaborateurs -->
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="card border-0 shadow-sm" style="border-radius: 16px;">
                    <div class="card-body">
                        <h6 class="font-weight-bold mb-3">
                            <i class="icon-filter3 mr-2"></i>Filtrer par sous-collaborateur
                        </h6>
                        <div class="d-flex flex-wrap gap-2">
                            <button class="btn btn-xs mr-2 mb-2"
                                [ngClass]="!selectedSousId ? 'btn-primary' : 'btn-light'" (click)="resetFilter()">
                                Tous
                            </button>
                            <button *ngFor="let sc of sousCollaborateurs" class="btn btn-xs mr-2 mb-2"
                                [ngClass]="selectedSousId === sc.id ? 'btn-primary' : 'btn-light'"
                                (click)="filterBySous(sc.id)">
                                {{ sc.prenom }} {{ sc.nom }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Graphiques -->
        <div class="row mt-4">

            <!-- Doughnut Actifs/Passifs -->
            <div class="col-md-4">
                <div class="card border-0 shadow-sm" style="border-radius: 16px;">
                    <div class="card-body">
                        <h6 class="font-weight-bold mb-3 text-center">Répartition Actifs / Passifs</h6>
                        <canvas #actifChart></canvas>
                    </div>
                </div>
            </div>

            <!-- Bar HT/TTC -->
            <div class="col-md-8">
                <div class="card border-0 shadow-sm" style="border-radius: 16px;">
                    <div class="card-body">
                        <h6 class="font-weight-bold mb-3 text-center">Montants HT / TTC</h6>
                        <canvas #htTtcChart></canvas>
                    </div>
                </div>
            </div>

        </div>

        <!-- Liste des clients -->
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="card border-0 shadow-sm" style="border-radius: 16px;">
                    <div class="card-header border-0" style="border-radius: 16px 16px 0 0; background: #f8f9fa;">
                        <h6 class="font-weight-bold mb-0">
                            <i class="icon-list mr-2"></i>
                            Liste des clients
                            <span class="badge badge-primary ml-2">{{ clients.length }}</span>
                            <span class="ml-3 text-muted font-weight-normal" *ngIf="selectedSousId">
                                — filtré par sous-collaborateur
                            </span>
                        </h6>
                    </div>
                    <div class="card-body p-0">
                        <table class="table table-hover mb-0">
                            <thead style="background: #f8f9fa;">
                                <tr>
                                    <th class="pl-4">#</th>
                                    <th>Entreprise</th>
                                    <th>Dirigeant</th>
                                    <th>Montant HT</th>
                                    <th>Montant TTC</th>
                                    <th>Collaborateur</th>
                                    <th>Statut</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let client of clients; let i = index">
                                    <td class="pl-4">{{ i + 1 }}</td>
                                    <td><strong>{{ client.company_name }}</strong></td>
                                    <td>{{ client.director_name }}</td>
                                    <td>{{ client.somme_ht | number:'1.2-2' }} €</td>
                                    <td>{{ client.somme_ttc | number:'1.2-2' }} €</td>
                                    <td>
                                        <span *ngFor="let c of client.collaborateurs" class="badge badge-info mr-1">
                                            {{ c.prenom }}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="badge" [ngClass]="client.actif ? 'badge-success' : 'badge-danger'">
                                            {{ client.actif ? 'Actif' : 'Passif' }}
                                        </span>
                                    </td>
                                    <td>
                                        <button class="btn btn-xs btn-warning"
                                            [routerLink]="['/admins', client.id, 'modify-client']">
                                            <i class="icon-pencil7"></i> Modifier
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="clients.length === 0">
                                    <td colspan="8" class="text-center text-muted py-4">
                                        Aucun client trouvé
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>